// extracted by mini-css-extract-plugin
export default {"kcbUnique":"kcbUnique_kcbUnique__JzfdL"};